<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Paramétrage des heures d'ouverture <strong></strong>  
          </div>
          <b-row class="form-group">
            <b-col md="2" v-if="display_atm">
              <dt class="col-sm-12">Lundi</dt>
            </b-col>
            <b-col md="2" v-if="display_atm">
                <el-switch v-model="planning.horaires[0].journees[1].ouvert"
                @change="choose_code"
                active-text="Ouvert"
                inactive-color="#ff4949"
                inactive-text="Fermé"></el-switch>
            </b-col>
            <b-col md="4" v-if="display_atm">
                <el-time-select
                    :disabled="grise_element1 == true"
                    placeholder="Heure d'ouverture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[1].heure_ouverture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00'
                    }">
                  </el-time-select>
            </b-col>
            <b-col md="4" v-if="display_atm">
                  <el-time-select
                    :disabled="grise_element1 == true"
                    placeholder="Heure de fermeture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[1].heure_fermeture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00',
                      minTime: planning.horaires[0].journees[1].heure_ouverture
                    }">
                  </el-time-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="2" v-if="display_atm">
              <dt class="col-sm-12">Mardi</dt>
            </b-col>
            <b-col md="2" v-if="display_atm">
                <el-switch v-model="planning.horaires[0].journees[2].ouvert"
                 @change="choose_code"
                inactive-color="#ff4949"
                active-text="Ouvert"
                inactive-text="Fermé"></el-switch>
            </b-col>
            <b-col md="4" v-if="display_atm">
                <el-time-select
                    :disabled="grise_element2 == true"
                    placeholder="Heure d'ouverture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[2].heure_ouverture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00'
                    }">
                  </el-time-select>
            </b-col>
            <b-col md="4" v-if="display_atm">
                  <el-time-select
                    :disabled="grise_element2 == true"
                    placeholder="Heure de fermeture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[2].heure_fermeture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00',
                      minTime: planning.horaires[0].journees[2].heure_ouverture
                    }">
                  </el-time-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="2" v-if="display_atm">
              <dt class="col-sm-12">Mercredi</dt>
            </b-col>
            <b-col md="2" v-if="display_atm">
                <el-switch v-model="planning.horaires[0].journees[3].ouvert"
                 @change="choose_code"
                active-text="Ouvert"
                inactive-color="#ff4949"
                inactive-text="Fermé"></el-switch>
            </b-col>
            <b-col md="4" v-if="display_atm">
                <el-time-select
                    :disabled="grise_element3 == true"

                    placeholder="Heure d'ouverture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[3].heure_ouverture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00'
                    }">
                  </el-time-select>
            </b-col>
            <b-col md="4" v-if="display_atm">
                  <el-time-select
                    :disabled="grise_element3 == true"
                    placeholder="Heure de fermeture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[3].heure_fermeture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00',
                      minTime: planning.horaires[0].journees[3].heure_ouverture
                    }">
                  </el-time-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="2" v-if="display_atm">
              <dt class="col-sm-12">Jeudi</dt>
            </b-col>
            <b-col md="2" v-if="display_atm">
                <el-switch v-model="planning.horaires[0].journees[4].ouvert"
                @change="choose_code"
                active-text="Ouvert"
                inactive-color="#ff4949"
                inactive-text="Fermé"></el-switch>
            </b-col>
            <b-col md="4" v-if="display_atm">
                <el-time-select
                    :disabled="grise_element4 == true"
                    placeholder="Heure d'ouverture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[4].heure_ouverture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00'
                    }">
                  </el-time-select>
            </b-col>
            <b-col md="4" v-if="display_atm">
                  <el-time-select
                    :disabled="grise_element4 == true"
                    placeholder="Heure de fermeture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[4].heure_fermeture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00',
                      minTime: planning.horaires[0].journees[4].heure_ouverture
                    }">
                  </el-time-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="2" v-if="display_atm">
              <dt class="col-sm-12">Vendredi</dt>
            </b-col>
            <b-col md="2" v-if="display_atm">
                <el-switch v-model="planning.horaires[0].journees[5].ouvert"
                active-text="Ouvert"
                 @change="choose_code"
                inactive-color="#ff4949"
                inactive-text="Fermé"></el-switch>
            </b-col>
            <b-col md="4" v-if="display_atm">
                <el-time-select
                    :disabled="grise_element5 == true"
                    placeholder="Heure d'ouverture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[5].heure_ouverture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00'
                    }">
                  </el-time-select>
            </b-col>
            <b-col md="4" v-if="display_atm">
                  <el-time-select
                    :disabled="grise_element5 == true"
                    placeholder="Heure de fermeture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[5].heure_fermeture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00',
                      minTime: planning.horaires[0].journees[5].heure_ouverture
                    }">
                  </el-time-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="2" v-if="display_atm">
              <dt class="col-sm-12">Samedi</dt>
            </b-col>
            <b-col md="2" v-if="display_atm">
                <el-switch v-model="planning.horaires[0].journees[6].ouvert"
                active-text="Ouvert"
                 @change="choose_code"
                inactive-color="#ff4949"
                inactive-text="Fermé"></el-switch>
            </b-col>
            <b-col md="4" v-if="display_atm">
                <el-time-select
                    :disabled="grise_element6 == true"
                    placeholder="Heure d'ouverture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[6].heure_ouverture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00'
                    }">
                  </el-time-select>
            </b-col>
            <b-col md="4" v-if="display_atm">
                  <el-time-select
                    :disabled="grise_element6 == true"
                    placeholder="Heure de fermeture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[6].heure_fermeture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00',
                      minTime: planning.horaires[0].journees[6].heure_ouverture
                    }">
                  </el-time-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="2" v-if="display_atm">
              <dt class="col-sm-12">Dimanche</dt>
            </b-col>
            <b-col md="2" v-if="display_atm">
                <el-switch v-model="planning.horaires[0].journees[0].ouvert"
                active-text="Ouvert"
                 @change="choose_code"
                inactive-color="#ff4949"
                inactive-text="Fermé"></el-switch>
            </b-col>
            <b-col md="4" v-if="display_atm">
                <el-time-select
                    :disabled="grise_element0 == true"
                    placeholder="Heure d'ouverture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[0].heure_ouverture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '21:00'
                    }">
                  </el-time-select>
            </b-col>
            <b-col md="4" v-if="display_atm">
                  <el-time-select
                    :disabled="grise_element0 == true"
                    placeholder="Heure de fermeture"
                    style="width: 100%;"
                    v-model="planning.horaires[0].journees[0].heure_fermeture"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '23:45',
                      minTime: planning.horaires[0].journees[0].heure_ouverture
                    }">
                  </el-time-select>
            </b-col>
          </b-row>
         
         
          <div slot="footer">
            <span v-if="can('horaires-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/';
export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      bool_horaire: false,
      response:{},
      grise_element0: false,
      grise_element1: false,
      grise_element2: false,
      grise_element3: false,
      grise_element4: false,
      grise_element5: false,
      grise_element6: false,
      endTime: '',
      value1:'',
      userConnected:{},
      display_atm:true,
      options : [],
      options_atm : [],
      planning:{
        "horaires":[
        {"entite_id":"",
        "journees":[
          {"jour_semaine":0, "ouvert":true, "heure_ouverture":"", "heure_fermeture":""},
          {"jour_semaine":1, "ouvert":true, "heure_ouverture":"", "heure_fermeture":""},
          {"jour_semaine":2, "ouvert":true, "heure_ouverture":"", "heure_fermeture":""},
          {"jour_semaine":3, "ouvert":true, "heure_ouverture":"", "heure_fermeture":""},
          {"jour_semaine":4, "ouvert":true, "heure_ouverture":"", "heure_fermeture":""},
          {"jour_semaine":5, "ouvert":true, "heure_ouverture":"", "heure_fermeture":""},
          {"jour_semaine":6, "ouvert":true, "heure_ouverture":"", "heure_fermeture":""} 
        ]}]
      },
      pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < (Date.now()- 3600 * 1000 * 24);
          },
          shortcuts: [{
            text: "Aujourd'hui",
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: 'Hier',
            onClick(picker) {
              const date = new Date();
              
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: 'Semaine avant',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
      },
      user:[],
      atm:[],
      guichet:{},
      value5: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],

      options4: [],
      options5: [],
      value9: [],
      list: [],
      loading: false,
      states: []
    }
  },
  methods:{
      goBack() {
        this.$router.go(-1)
      },
      choose_code(){
        if(this.planning.horaires[0].journees[1].ouvert==false){
          this.grise_element1= true
          this.planning.horaires[0].journees[1].heure_ouverture=null
          this.planning.horaires[0].journees[1].heure_fermeture=null
        }else{
          this.grise_element1= false
        }
        if(this.planning.horaires[0].journees[2].ouvert==false){
          this.grise_element2= true
          this.planning.horaires[0].journees[2].heure_ouverture=null
          this.planning.horaires[0].journees[2].heure_fermeture=null
        }else{
          this.grise_element2= false
        }
        if(this.planning.horaires[0].journees[3].ouvert==false){
          this.grise_element3= true
          this.planning.horaires[0].journees[3].heure_ouverture=null
          this.planning.horaires[0].journees[3].heure_fermeture=null
        }else{
          this.grise_element3= false
        }
        if(this.planning.horaires[0].journees[4].ouvert==false){
          this.grise_element4= true
          this.planning.horaires[0].journees[4].heure_ouverture=null
          this.planning.horaires[0].journees[4].heure_fermeture=null
        }else{
          this.grise_element4= false
        }
        if(this.planning.horaires[0].journees[5].ouvert==false){
          this.grise_element5= true
          this.planning.horaires[0].journees[5].heure_ouverture=null
          this.planning.horaires[0].journees[5].heure_fermeture=null
        }else{
          this.grise_element5= false
        }
        if(this.planning.horaires[0].journees[6].ouvert==false){
          this.grise_element6= true
          this.planning.horaires[0].journees[6].heure_ouverture=null
          this.planning.horaires[0].journees[6].heure_fermeture=null
        }else{
          this.grise_element6= false
        }
        if(this.planning.horaires[0].journees[0].ouvert==false){
          this.grise_element0= true
          this.planning.horaires[0].journees[0].heure_ouverture=null
          this.planning.horaires[0].journees[0].heure_fermeture=null
        }else{
          this.grise_element0= false
        }
      },
      countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      async get_all_planning(){
        let response = await api.entity.get_balance_entites(token)
        this.entite_id = response.data.data.id
        let response_horaire = await api.planning.get_all_planning_by_entite(this.entite_id)
        console.log("restre ",response_horaire.data.data)
        let horaire = response_horaire.data.data
        if (horaire.length>0){
            console.log(horaire[0].id)
            this.planning.horaires[0].journees[0].id = horaire[0].id
            this.planning.horaires[0].journees[1].id = horaire[1].id
            this.planning.horaires[0].journees[2].id = horaire[2].id
            this.planning.horaires[0].journees[3].id = horaire[3].id
            this.planning.horaires[0].journees[4].id = horaire[4].id
            this.planning.horaires[0].journees[5].id = horaire[5].id
            this.planning.horaires[0].journees[6].id = horaire[6].id
            if(horaire[1].ouvert==1){
              this.planning.horaires[0].journees[1].heure_ouverture=horaire[1].heure_ouverture.substring(0, 5);
              this.planning.horaires[0].journees[1].heure_fermeture=horaire[1].heure_fermeture.substring(0, 5);
            }else{
              this.grise_element1 = false
              this.planning.horaires[0].journees[1].ouvert=false
            }
            if(horaire[2].ouvert==1){
              this.planning.horaires[0].journees[2].heure_ouverture=horaire[2].heure_ouverture.substring(0, 5);
              this.planning.horaires[0].journees[2].heure_fermeture=horaire[2].heure_fermeture.substring(0, 5);
            }else{
              this.grise_element2 = false
              this.planning.horaires[0].journees[2].ouvert=false
            }
            if(horaire[3].ouvert==1){
              this.planning.horaires[0].journees[3].heure_ouverture=horaire[3].heure_ouverture.substring(0, 5);
              this.planning.horaires[0].journees[3].heure_fermeture=horaire[3].heure_fermeture.substring(0, 5);
            }else{
               this.grise_element3 = false
               this.planning.horaires[0].journees[3].ouvert=false
            }

            if(horaire[4].ouvert==1){
              this.planning.horaires[0].journees[4].heure_ouverture=horaire[4].heure_ouverture.substring(0, 5);
              this.planning.horaires[0].journees[4].heure_fermeture=horaire[4].heure_fermeture.substring(0, 5);
            }else{
              this.grise_element4 = false
              this.planning.horaires[0].journees[4].ouvert=false
            }

            if(horaire[5].ouvert==1){
              this.planning.horaires[0].journees[5].heure_ouverture=horaire[5].heure_ouverture.substring(0, 5);
              this.planning.horaires[0].journees[5].heure_fermeture=horaire[5].heure_fermeture.substring(0, 5);
            
            }else{
              this.grise_element5 = false
              this.planning.horaires[0].journees[5].ouvert=false
            }

            if(horaire[6].ouvert==1){
              this.planning.horaires[0].journees[6].heure_ouverture=horaire[6].heure_ouverture.substring(0, 5);
              this.planning.horaires[0].journees[6].heure_fermeture=horaire[6].heure_fermeture.substring(0, 5);
            
            }else{
              this.grise_element6 = false
              this.planning.horaires[0].journees[6].ouvert=false
            }

            if(horaire[0].ouvert==1){
              this.planning.horaires[0].journees[0].heure_ouverture=horaire[0].heure_ouverture.substring(0, 5);
              this.planning.horaires[0].journees[0].heure_fermeture=horaire[0].heure_fermeture.substring(0, 5);
        
            }else{
              this.grise_element0 = false
              this.planning.horaires[0].journees[0].ouvert=false
            }

            this.bool_horaire=true
            
        }else{
            this.bool_horaire = false
        }
        console.log("heure bool : ",this.bool_horaire)
      },
      showAlert () {
        this.dismissCountDown = this.dismissSecs
      },
      can(perm){
        return store.getters['auth/can'](perm)
      },
      async post(){     
          
          console.log(this.planning)
          if (this.bool_horaire==false){
            this.response = await this.$store.dispatch('planning/post_horaire',this.planning)
          }else{
            this.response = await this.$store.dispatch('planning/put_horaire',this.planning)
          }
          this.showAlert()
          if (this.response.success==true){

            this.reset()
          }
          //this.planning.horaires[0].date = temp_date
      },
      async get_all_users(){
          let response = await api.entity.get_balance_entites(token)
          this.planning.horaires[0].entite_id = response.data.data.id
          //console.log("resr ", response.data.data)
          this.userConnected = await store.getters['auth/get_user']
          let serverParams = {
              name:'',
              email:'',
              entite_nom:'',
              agence_nom:'',
              agence_ville:'',
              role_name:'',
              created_at:'',
              page:1,
              current_page: 1,
              nb_lines:10

          }
          await this.$store.dispatch('user/get_all_users',serverParams).then(()=>{
              return this.user = store.getters['user/rows'];    
          })
          //if (this.userConnected.role.toUpperCase() == 'CHEF AGENCE'){
          //let users=this.user.filter(element=>element.role.toUpperCase() != 'CHEF AGENCE')
          this.user.forEach((element)=>{
              this.options.push({
                value:element.id,
                text:element.name
              })
          })    
      },
      async get_all_atm(){
          let serverParams = {
              page:1
          }
          //this.atm =  store.getters['atm/rows'];
          if(this.$route.params.guichet_id===null || this.$route.params.guichet_id==='null'){
            await this.$store.dispatch('atm/get_all_atms_own',serverParams).then(()=>{
              return this.atm = store.getters['atm/rows'];    
            })
            this.display_atm = true
            this.atm.forEach((element)=>{
              this.options_atm.push({
                value:element.id,
                  text:element.nom
                })
            })
          }else{
            await this.$store.dispatch('atm/show_guichets',this.$route.params.guichet_id).then((res)=>{
              return this.guichet = res   
            })
            this.display_atm = false
            this.planning.horaires[0].guichet_id = this.$route.params.guichet_id
            this.options_atm.push({
              value:this.$route.params.guichet_id,
              text:this.$route.params.guichet_id
            })
          }
      },
      
      reset() {
        // this.planning.horaires[0].date= '',
        // this.planning.horaires[0].heure_debut= '',
        // this.planning.horaires[0].heure_fin= ''
      },

  },
  mounted(){
    this.get_all_planning()
    this.get_all_users()
  }
}
</script>
